import RenderText from "./RenderText";

export default RenderText;